<template>
<!-- 工厂档案被查看趋势 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">工厂档案被查看趋势</div>
                <!-- <el-popover placement="right" trigger="hover" width="300">
                    <div>
                        <p>查看询盘次数：客户查看全部询盘总次数</p>
                        <p>报价次数：客户报价次数，同一询盘多次报价重复计.（不含草稿、已撤回、已撤销报价）</p>
                    </div>
                    <i slot="reference" class="iconfont icon-icon-zhuming2" ></i>
                </el-popover> -->
            </div>
           
        </div>
        <div v-loading='loading' class="col-chart-view" style="height: 280px; display: flex;justify-content: center;">
            <div ref="echart" style=" width:100%;margin-top:20px"></div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import windowAddEvent from '@/utils/windowAddEvents';
import {  getDataAssistant } from "@/utils/api/dashboard";

export default  {
    data(){
        return {
            echartsObj:  '',
            userVisitData:{},
            loading: false
        }
    },
    methods:{
        //获取数据
        getUserVisitData(){
            this.loading = true;
            const params = {
                startDate: moment(new Date().setMonth(new Date().getMonth()-6)).format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                enums:['TREND']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.userVisitData = res.data;
                    this.addListData();
                    this.loading = false;
                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("获取图标数据失败啦~System error",err);
            })
        },

        init(currentData) {
            let interval=  0;
            let options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    left: '20',
                    top: '19',
                    itemWidth: 14,
                    itemHeight: 7,
                    textStyle: {
                        color: "#666",
                        fontSize: 12,
                        fontFamily: "PingFangSC-Regular",
                        lineHeight: 17
                    },
                },
                grid: {
                    top:10,
                    left: 45,
                    right: 32,
                    // containLabel: true
                },
                toolbox: {
                    feature: {
                        // saveAsImage: {}
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    alignTicks:false,
                    axisTick: {
                        show:true,
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#EDF0F4"
                        }
                    },
                    axisLabel: {
                        interval,
                        rotate: 50,
                        margin: 10,
                        color: "#666",
                        fontSize: 10,
                        fontFamily: "PingFangSC-Medium",
                        lineHeight: 17
                    },
                    data: currentData.x
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#ccc"
                        }
                    },
                    axisLabel: {
                        formatter: (value, index)=> {
                            if(value.toString().indexOf('.') > -1) {
                                return "";
                            }
                            return value;
                        }
                    }
                },
               
                series: [
                    {
                        type: "line",
                        // name:'档案浏览统计',
                        symbol: "none",
                        // smooth: true,
                        itemStyle: {
                            normal:{
                                borderColor: '#3A69F4',
                                borderWidth: 1,
                                color: "#fff",
                                lineStyle: {
                                    width: 1,
                                    color: "#3A69F4"
                                },
                            }
                        },
                        data: currentData.xpData,
                        symbol:'circle',
                        symbolSize: 5,
                        areaStyle: {  //区域样式
                            color:{
                                type: 'linear',
                                x: 0.2,
                                y: 0,
                                x2: 0.2,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#3A69F4' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#fff' // 100% 处的颜色
                                }],
                            }
                        },
                        
                    },
                    
                ]
            };
            this.echartsObj.clear();
            this.echartsObj.setOption(options);
        },
    
        handleListData(data) {
            let {bjCount, xpCount} = data;
            let x=  [];
            let bjData= bjCount.map((item) => {
                x.push(item.title);
                return  item.num;
            });
            let xpData=  xpCount.map((item) => {
                return  item.num;
            });
            return {
                x,
                bjData,
                xpData
            };
        },
    
        addListData() {
          let resultData=
                {
                    bjCount: this.userVisitData.trend,
                    xpCount: this.userVisitData.trend
                }
            const handledData = this.handleListData(resultData);
            this.init(handledData)
        },
       
    },
    mounted() {
        this.getUserVisitData()
        let ele = this.$refs.echart;
        this.echartsObj = this.$echarts.init(ele);
        windowAddEvent('resize', this.echartsObj.resize);
    },

}
</script>

<style lang="scss" >

</style>